import PropTypes from 'prop-types';

export default {
	reviewData: PropTypes.shape({
		currentBalance: PropTypes.number,
		effectiveWarningReason: PropTypes.string,
		repeatData: PropTypes.shape({
			amount: PropTypes.number,
			endValue: PropTypes.string, // noOfPayments for stopWhen=2, endDate for sstopWhen=3
			howOften: PropTypes.string,
			oneOffPayment: PropTypes.bool,
			reference: PropTypes.string,
			startDate: PropTypes.string,
			stopWhen: PropTypes.oneOf(['1', '2', '3']),
		}),
		content: PropTypes.shape({
			oneOffPayment: PropTypes.string,
			repeatingPayment: PropTypes.string,
		}),
		repeatPaymentOptions: PropTypes.shape({
			isFormVisible: PropTypes.bool,
			isTransfer: PropTypes.bool,
		}),
	}),
};
